import React from "react";
import "./App.pages.css";
import TestimonialsSection from "../components/TestimonialsSection";
import ContactBanner from "../components/ContactBanner";
import Header from "../components/Header";
import Particles from "react-particles-js";
import AboutSection from "../components/AboutSection";
import ProjectSection from "../components/ProjectSection";
import ServicesSection from "../components/ServicesSection";

export default function Home() {
  return (
    <>
      <Particles
        className="particles-canvas"
        params={{
          particles: {
            number: {
              value: 80,
              density: {
                enable: true,
                value_area: 900,
              },
            },
          },
          interactivity: {
            events: {
              onhover: {
                enable: true,
                mode: "repulse",
              },
            },
          },
          shape: {
            type: "star",
            stroke: {
              width: 8,
              color: "#f9ab00",
            },
          },
        }}
      ></Particles>
      <Header />
      <div className="container">
        <AboutSection />
        <ServicesSection />
        <ProjectSection />
        <TestimonialsSection />
        <ContactBanner />
      </div>
    </>
  );
}
